export const NotesBookmarksModule = {
    state: {
        noteBookmarksCount: {
            section: 0,
            titles: 0
        }
    },
    getters: {
        getSectionNoteBookmarksCount: (state) => state.noteBookmarksCount.section,
        getTitlesNoteBookmarksCount: (state) => state.noteBookmarksCount.titles,
    },
    mutations: {
        setNoteBookmarksCount(state, { type, count }) {
            state.noteBookmarksCount[type] = count;
        }
    },
    actions: {
        updateNoteBookmarksCount({ commit }, payload) {
            commit('setNoteBookmarksCount', payload);
        }
    }
}
